import { Statistic } from 'antd';
import TableLoading from './TableLoading';
import { formatCurrencyNew, formatHyphenatedText, mapTimeRangeToApiFilterAlt3 } from '../services/utilities';

export const MetricCardAlt = ({ loading, value, label, total, color, currentRange }) => {
	const percentage = value != null && total > 0 ? ((value / total) * 100).toFixed(1) : 0;

	return (
		<div className="col-3">
			<a className="element-box el-tablo" href="#">
				<Statistic
					title={label}
					value={
						loading ? (
							<TableLoading />
						) : value != null ? (
							Number(value) > 1000000 ? (
								formatCurrencyNew(Number(value))
							) : (
								Number(value).toLocaleString()
							)
						) : (
							'0'
						)
					}
					valueStyle={{ fontWeight: 'bold', color }}
				/>
				{label?.endsWith('Amount') ? (
					<small className="text-muted">{label} for</small>
				) : label !== 'Total Requests' ? (
					<small className="text-muted">
						<strong style={{ color }}>{percentage}%</strong> of Total Requests for{' '}
					</small>
				) : (
					<small className="text-muted">Total Requests</small>
				)}{' '}
				<small className="text-muted">
					<strong>{formatHyphenatedText(mapTimeRangeToApiFilterAlt3(currentRange))}</strong>
				</small>
			</a>
		</div>
	);
};
